/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
import * as React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MainLogo from '../../../components/MainLogo/MainLogo.components';
import CloseIcon from '@mui/icons-material/Close';

type ExitWithoutSavingModalType = {
  open: boolean;
  handleClose: () => void;
  onExist: () => void;
};

const ExitWithoutSavingModal = ({ open, handleClose, onExist }: ExitWithoutSavingModalType) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={'xs'}
    >
      <DialogTitle id="alert-dialog-title">
        <Box className="DialogHeadingBox">
          {/* <Box>
            <MainLogo />
          </Box> */}
          {/* <Box className="CloseIcon">
              <IconButton onClick={DeleteAccountClose}>
                <CloseIcon />
              </IconButton>
            </Box> */}
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box sx={{ mb: 2 }}>
            <Typography variant="h2">Exit Without Saving</Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2">
              Are you sure you want to leave without saving your work? Any changes you've made to
              your scene will be lost.
            </Typography>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className="CommonModalButton FullWidthButton"
          color="primary"
          variant="outlined"
          onClick={handleClose}
        >
          No, Go Back
        </Button>
        <Button
          className="CommonModalButton FullWidthButton"
          color="secondary"
          variant="contained"
          onClick={onExist}
        >
          Exit Without Saving
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExitWithoutSavingModal;
